import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ScrollTop from './components/ScrollTop/ScrollTop';
import CompanyInfo from './pages/CompanyInfo/CompanyInfo';
import Event from './pages/Event/Event';
import Faq from './pages/Faq/Faq';
import Home from './pages/Home/Home';
import MyOrder from './pages/MyOrder/MyOrder';
import MyPage from './pages/MyPage/MyPage';
import Notice from './pages/Notice/Notice';
import Order from './pages/Order/Order';
import OrderContinue from './pages/OrderContinue/OrderContinue';
import OrderDetail from './pages/OrderDetail/OrderDetail';
import ProductDetail from './pages/ProductDetail/ProductDetail';
import ProductDetail2 from './pages/ProductDetail/ProductDetail';
import ProductList from './pages/ProductList/ProductList';
import Review from './pages/Review/Review';
import { isDesktop } from 'react-device-detect';
import Basket from './pages/Basket/Basket';
import Pick from './pages/Pick/Pick';
import Terms from './pages/Terms/Terms';
import Guide from './pages/Guide/Guide';
import UnauthorizedEmailCollection from './pages/UnauthorizedEmailCollection/UnauthorizedEmailCollection';
import Privacy from './pages/Privacy/Privacy';
import PartnerClinic from './pages/PartnerClinic/PartnerClinic';
import Login from './pages/Login/Login';
import Point from './pages/Point/Point';
import Coupon from './pages/Coupon/Coupon';
import MyReview from './pages/MyReview/MyReview';
import OrderComplete from './pages/OrderComplete/OrderComplete';
import Join from './pages/Join/Join';
import axios from 'axios';
import Cookies from 'universal-cookie';
import JoinSuccess from './pages/JoinSuccess/JoinSuccess';
import Kakao from './auth/Kakao';
import MobileOKCallback from './auth/MobileOKCallback';
import EZIOKCallback from './auth/EZIOKCallback';
import MobileOKTest from './pages/MobileOKTest/MobileOKTest';
import Navigation from './components/Navigation/Navigation';
import OrderConfirm from './pages/OrderConfirm/OrderConfirm';
import HomeMobile from './mobilePages/HomeMobile/HomeMobile';
import UpdateProfile from './pages/UpdateProfile/UpdateProfile';
import MyCard from './pages/MyCard/MyCard';
import FindAccount from './pages/FindAccount/FindAccount';
import DeliveryDetail from './pages/DeliveryDetail/DeliveryDetail';
import Questionnaire from './pages/Questionnaire/Questionnaire';
import InAppGuide from './pages/InAppGuide/InAppGuide';
import GetGuideURL from './pages/GetGuideURL/GetGuideURL';
import Popup from './components/Popup/Popup';
import PageChangeAnimation from './components/PageChangeAnimation/PageChangeAnimation';
import EventDetail from './pages/EventDetail/EventDetail';
import Admin from './pages/Admin/Admin';
import SelectTreatmentMethod from './pages/SelectTreatmentMethod/SelectTreatmentMethod';
// import Challenge from './pages/Challenge/Challenge';
// import MyChallenge from './pages/MyChallenge/MyChallenge';
import MyWeight from './pages/MyWeight/MyWeight';
// import ChallengeDetail from './pages/ChallengeDetail/ChallengeDetail';
import WeightChart from './pages/WeightChart/WeightChart';
import WeightList from './pages/WeightList/WeightList';
import WeightDate from './pages/WeightDate/WeightDate';
import WeightDateChart from './pages/WeightDateChart/WeightDateChart';
import WeightPoint from './pages/WeightPoint/WeightPoint';
import Referral from './pages/Referral/Referral';
import ReferralPoint from './pages/ReferralPoint/ReferralPoint';
import ProgramList from './pages/ProgramList/ProgramList';
import { ITokenInfoType, loginCheck, logout } from './auth/auth';
import jwt_decode from 'jwt-decode';
import ChannelService from './ChannelService';
import axiosClient from './libs/axiosClient';
import OrderAddress from './pages/OrderAddress/OrderAddress';
import PayModal from './components/PayModal/PayModal';
import NonMyOrder from './pages/NonMyOrder/NonMyOrder';
import ChannelAlert from './components/ChannelAlert/ChannelAlert';
import SubscribeDetail from './pages/SubscribeDetail/SubscribeDetail';
import DeliveryChange from './pages/DeliveryChange/DeliveryChange';
import DietProgram from './pages/DietProgram/DietProgram';
import DietAlert from './pages/DietAlert/DietAlert';
import DietManagement from './pages/DietManagement/DietManagement';
import DietFoodDetail from './pages/DietFoodDetail/DietFoodDetail';
import DietQna from './pages/DietQna/DietQna';
import SubscribeOrderDetail from './pages/SubscribeOrderDetail/SubscribeOrderDetail';
import DietProgramSummary from './pages/DietProgramSummary/DietProgramSummary';
import CardRegister from './pages/CardRegister/CardRegister';

function App() {
  let memberId = '';
  let memberHash = '';
  const [combineOrderId, setCombineOrderId] = useState('');
  const [payModalOpen, setPayModalOpen] = useState(true);
  const [inappModalOpen, setInappModalOpen] = useState(false);
  const [id, setId] = useState('');
  const [channelAlert, setChannelAlert] = useState(false);

  useEffect(() => {
    const isFirstVisit = sessionStorage.getItem('isFirstVisit');
    if (
      !isFirstVisit &&
      navigator.userAgent.match(
        /inapp|NAVER|KAKAOTALK|Snapchat|Line|WirtschaftsWoche|Thunderbird|Instagram|everytimeApp|WhatsApp|Electron|wadiz|AliApp|zumapp|iPhone(.*)Whale|Android(.*)Whale|kakaostory|band|twitter|DaumApps|DaumDevice\/mobile|FB_IAB|FB4A|FBAN|FBIOS|FBSS|SamsungBrowser\/[^1]/i,
      )
    )
      setInappModalOpen(true);
  }, []);
  useEffect(() => {
    const userAgentLower = navigator.userAgent.toLowerCase();
    const mobileAppUserAgent = userAgentLower.match(/payple-pay-app/i);

    if (isDesktop) document.body.classList.add('pc');
    if (mobileAppUserAgent) document.documentElement.classList.add('mobile');

    if (mobileAppUserAgent) {
      localStorage.setItem('mobileApp', mobileAppUserAgent.toString());
      document.body.style.userSelect = 'none';
      return () => {
        document.body.style.userSelect = 'auto';
      };
    } else localStorage.removeItem('mobileApp');
  }, []);

  const getHash = async () => {
    await axiosClient
      .get('/data/channeltalk/hash', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })
      .then((res) => {
        memberHash = res.data;
        getChannel();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getChannel = async () => {
    let profile = {};

    // 로그인한 사용자의 경우 채널톡 프로필 정보 가져오기
    if (loginCheck()) {
      try {
        const response = await axiosClient.get('/data/channeltalk/profile');
        const data = response.data.data;

        if (!data) {
          console.log('No channel talk profile data');
        } else {
          // 쿠폰 정보 문자열 생성
          let couponInfo = '';
          if (data.coupons && data.coupons.length > 0) {
            couponInfo = data.coupons.map((coupon: any) =>
                `${coupon.name} (${coupon.discount}, ~${coupon.expire_date})`
            ).join(' / ');
          } else {
            couponInfo = '없음';
          }

          // 순서대로 프로필 구성
          profile = {
            '회원아이디': data.member_id || '',
            '총주문건수': data.total_order_count || 0,
            '보유적립금': data.total_point ? `${data.total_point.toLocaleString()}원` : '0원',
            '보유쿠폰': couponInfo,
          };

          // 최근 주문 정보 추가
          if (data.latest_order) {
            const latestOrder = data.latest_order;
            (profile as any)['최근주문일자'] = latestOrder.order_date || '';
            (profile as any)['최근주문번호'] = latestOrder.order_id || '';
            (profile as any)['최근주문상품'] = latestOrder.order_title || '';
            (profile as any)['최근주문상태'] = latestOrder.status || '';
            (profile as any)['최근주문금액'] = latestOrder.order_amount ? `${latestOrder.order_amount.toLocaleString()}원` : '';
          }
        }
      } catch (err) {
        console.log('Failed to fetch channel talk profile:', err);
      }
    }
    ChannelService.boot({
      pluginKey: '3c7f74d3-0628-4b52-bcb2-0cfb99ca0751',
      profile: Object.keys(profile).length > 0 ? profile : undefined,
      memberId: memberId,
      memberHash: memberHash,
    });
    // 채널톡 클릭 시 배너
    // ChannelService.onShowMessenger(function onShow() {
    //   setChannelAlert(true);
    // });
  };

  // 채널톡 닫히면 배너
  // ChannelService.onHideMessenger(function onHide() {
  //   setChannelAlert(false);
  // });

  const getStepCookie = () => {
    axiosClient
      .get('https://api.ondoc.co.kr/data/survey/cookie', {
        withCredentials: true,
      })
      .then((res) => {})
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    ChannelService.loadScript();
    if (loginCheck()) {
      axiosClient.get('/data/combined_order').then((res) => {
        if (res.data.order_id) {
          setCombineOrderId(res.data.order_id);
          setPayModalOpen(true);
        }
      });

      const token = localStorage.getItem('token');
      if (token == null || token == 'null') return;
      const decodedUserInfo: ITokenInfoType = jwt_decode(token!);
      memberId = decodedUserInfo.id.toString();
      getHash();
    } else {
      getStepCookie();
      getChannel();
    }
  }, []);

  return (
    <div>
      <BrowserRouter>
        {/* {inappModalOpen && <InAppModal setOpen={setInappModalOpen} />} */}
        {/*{window.location.pathname === '/' && <Popup />}*/}
        {combineOrderId && payModalOpen && (
          <PayModal closer={setPayModalOpen} orderId={combineOrderId} />
        )}
        <PageChangeAnimation />
        <ScrollTop />
        <Routes>
          <Route path="/" element={isDesktop ? <Home /> : <HomeMobile />} />
          <Route path="/login" element={<Login />} />
          <Route path="/join" element={<Join />} />
          <Route path="/joinSuccess" element={<JoinSuccess />} />

          <Route path="/companyInfo" element={<CompanyInfo />} />
          <Route path="/productList" element={<ProductList />} />
          <Route path="/notice" element={<Notice />} />
          <Route path="/productDetail/:productId" element={<ProductDetail />} />
          <Route
            path="/productDetailSub/:productId"
            element={<ProductDetail2 />}
          />
          <Route path="/faq" element={<Faq />} />
          <Route path="/myPage" element={<MyPage />} />
          <Route path="/myOrder" element={<MyOrder />} />
          <Route path="/orderDetail/:orderNumber" element={<OrderDetail />} />
          <Route path="/event" element={<Event />} />
          <Route path="/event/:eventId" element={<EventDetail />} />
          {/* <Route
            path="/selectTreatmentMethod/:isDirect/:cartId"
            element={<SelectTreatmentMethod />}
          /> */}
          {/* <Route path="/order/:isDirect/:cartId" element={<Order />} /> */}
          <Route path="/order/:isDirect/:cartId" element={<Order />} />
          <Route
            path="/order-continue/:orderId"
            // path="/order-continue/:cartId"
            element={<OrderContinue />}
          />
          <Route
            path="/order-addr/:isDirect/:cartId"
            element={<OrderAddress />}
          />
          {/* <Route
            path="/questionnaire/:isDirect/:cartId"
            element={<Questionnaire />}
          /> */}
          <Route
            path="/questionnaire/:isDirect/:productId"
            element={<Questionnaire />}
          />
          <Route path="/review/:productId" element={<Review />} />
          <Route path="/basket" element={<Basket />} />
          <Route path="/pick" element={<Pick />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/guide" element={<Guide />} />
          <Route
            path="/unauthorizedEmailCollection"
            element={<UnauthorizedEmailCollection />}
          />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/partnerClinic" element={<PartnerClinic />} />
          <Route path="/point" element={<Point />} />
          <Route path="/coupon" element={<Coupon />} />
          <Route path="/myReview" element={<MyReview />} />
          <Route path="/updateProfile" element={<UpdateProfile />} />
          <Route path="/myCard" element={<MyCard />} />
          <Route path="/findAccount" element={<FindAccount />} />
          <Route
            path="/deliveryDetail/:deliveryCompany/:deliveryNumber"
            element={<DeliveryDetail />}
          />
          <Route
            path="/orderConfirm/:orderNumber/:result"
            element={<OrderConfirm />}
          />
          <Route
            path="/orderConfirm/:orderNumber/:result/:errorCode"
            element={<OrderConfirm />}
          />
          <Route
            path="/orderComplete/:orderNumber"
            element={<OrderComplete />}
          />
          <Route path="/auth/kakao/callback" element={<Kakao />} />
          <Route path="/auth/mobileok/callback" element={<MobileOKCallback />} />
          <Route path="/auth/eziok/callback" element={<EZIOKCallback />} />
          <Route path="/mobileok-test" element={<MobileOKTest />} />
          <Route path="/inAppGuide/:productId" element={<InAppGuide />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/getGuideURL" element={<GetGuideURL />} />
          {/* <Route path="/challenge" element={<Challenge />} /> */}
          {/* <Route path="/challengeDetail/:id" element={<ChallengeDetail />} /> */}
          {/* <Route path="/myChallenge" element={<MyChallenge />} /> */}
          <Route path="/myWeight" element={<MyWeight />} />
          <Route path="/myWeight/chart" element={<WeightChart />} />
          <Route path="/myWeight/list" element={<WeightList />} />
          <Route path="/myWeight/date" element={<WeightDate />} />
          <Route path="/myWeight/dateChart" element={<WeightDateChart />} />
          <Route path="/myWeight/point" element={<WeightPoint />} />
          <Route path="/referral" element={<Referral />} />
          <Route path="/referral-point" element={<ReferralPoint />} />
          <Route path="/program-list" element={<ProgramList />} />
          <Route path="/non-myorder" element={<NonMyOrder />} />
          <Route path="/subscribe-detail" element={<SubscribeDetail />} />
          <Route
            path="/subscribe-order-detail"
            element={<SubscribeOrderDetail />}
          />
          <Route path="/delivery-change" element={<DeliveryChange />} />
          <Route path="/dietprogram-summary" element={<DietProgramSummary />} />
          <Route path="/dietprogram" element={<DietProgram />} />
          <Route path="/diet-alert" element={<DietAlert />} />
          <Route path="/diet-management" element={<DietManagement />} />
          <Route path="/dietfood-detail/:dietId" element={<DietFoodDetail />} />
          <Route path="/diet-qna" element={<DietQna />} />
          <Route path="/card-register" element={<CardRegister />} />
        </Routes>
        <Navigation />
      </BrowserRouter>
      {/* {isDesktop && channelAlert && <ChannelAlert />} */}
    </div>
  );
}

export default App;
